var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8221 13.3136C10.4244 13.8876 9.57583 13.8876 9.17814 13.3136L5.89136 8.56949C5.43188 7.90629 5.90654 7 6.71336 7L13.2869 7C14.0937 7 14.5684 7.90629 14.1089 8.5695L10.8221 13.3136Z",
    fill: "#585771"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownG);
export default __webpack_public_path__ + "static/media/dropdown-g.409fc4d72acfe52e80253acfd61b0574.svg";
export { ForwardRef as ReactComponent };